export default __webpack_public_path__ + "static/media/prairie-dog.8ba223ab.webp";